import axios from "axios";
import moment from 'moment';
import { localEnvVariables } from "../constants/env";
import { BackendAxios } from "../interceptors/axiosInstance";
import { http_request } from "../interceptors/httpHandler";

export const getUserIpInfo = () => {
    return axios.get(`https://ipapi.co/json/`)
    // return axios.get(`https://ipinfo.io/json?token=${localEnvVariables.REACT_APP_IP_INFO_KEY}`)
    // return axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=${localEnvVariables.REACT_APP_IPGEOLOCATION_KEY}`)
}

export const getUserCoords = () => {
    return axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${localEnvVariables.REACT_APP_GOOGLE_GEOLOCATION_KEY}`)
}

export const getUserLocationDetailsByCoords = (lat, long) => {
    return axios.get(`https://api.opencagedata.com/geocode/v1/json?q=${lat}+${long}&key=${localEnvVariables.REACT_APP_OPENCAGEDATA_KEY}`)
}


// gifted
export const addGiftedCustomer = (data) => {
    return http_request('/gifted/giftedCustomerController/addGiftedCustomer', 'POST', data, false)
}

export const AllGiftedCustomerCreatedByGifter = data => {
    return http_request('/gifted/giftedCustomerController/AllGiftedCustomerCreatedByGifter', 'POST', { data })
}

export const findGiftedCustomerById = data => {
    return http_request('/gifted/giftedCustomerController/findGiftedCustomerById', 'POST', data)
}

export const getGiftedUsersByPayMode = payMode => {
    return http_request('/gifted/giftedCustomerController/regionWiseCustomer', 'POST', { isPaid: 1, payMode })
}

export const getPlanWiseCustomer = data => {
    return http_request('/gifted/giftedCustomerController/planWiseCustomer', 'POST', data);
}

export const getAllGiftedUsers = () => {
    return http_request('/gifted/giftedCustomerController/getAll', 'POST')
}

export const getInvoicesByRecieverId = (giftedUserId) => {
    return http_request('/gifted/giftedCustomerController/getInvoicesByRecieverId', 'POST', { data: giftedUserId })
}

export const findSenderRecieverInvoicePaid = () => {
    return http_request('/gifted/giftedCustomerController/findSenderRecieverInvoicePaid', 'POST')
}


// gifter
export const addUpdateGifter = data => {
    return http_request('/gifter/gifterController/addUpdateGifter', 'POST', data, false)
}

export const findGifterById = data => {
    return http_request('/gifter/gifterController/findGifterById', 'POST', data)
}

export const gifterOtpVerfication = data => {
    return http_request('/gifter/gifterController/gifterOtpVerfication', 'POST', data, false)
}

export const getTotalSales = (jwt) => {
    return http_request('/PlanBilling/getTotalSell', 'POST', { jwt }, true, {}, {}, BackendAxios)
}

export const getTotalCountByPlanId = ({ id, fromDate, toDate, jwt }) => {
    fromDate = moment(fromDate).add(1, 'day').utc().startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
    toDate = moment(toDate).add(1, 'day').utc().endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
    return http_request('/PlanBilling/getTotalCountByPlanId', 'POST', { id, fromDate, toDate, jwt }, true, {}, {}, BackendAxios)
}

export const getTotalSellBYPlanId = (id, jwt) => {
    return http_request('/PlanBilling/getTotalSellBYPlanId', 'POST', { id, jwt }, true, {}, {}, BackendAxios)
}

export const getOfferCodeCount = (jwt) => {
    return http_request('/PlanBilling/getOfferCodeCount', 'POST', { jwt }, true, {}, {}, BackendAxios)
}

export const getOfferCodeCountByOfferIdentifier = (offerIdentifier, jwt) => {
    return http_request('/PlanBilling/getOfferCodeCountByOfferIdentifier', 'POST', { offerIdentifier, jwt }, true, {}, {}, BackendAxios)
}